export var TemplateType;
(function (TemplateType) {
    TemplateType["EXPERIENCE"] = "EXPERIENCE";
    TemplateType["INDIVIDUAL_FUNDRAISER"] = "INDIVIDUAL_FUNDRAISER";
    TemplateType["TEAM_FUNDRAISER"] = "TEAM_FUNDRAISER";
    TemplateType["DONATION"] = "DONATION";
    TemplateType["THANK_YOU"] = "THANK_YOU";
    TemplateType["CAMPAIGN"] = "CAMPAIGN";
})(TemplateType || (TemplateType = {}));
